export const APPEARANCES = {
  white: 'white',
  gray: 'gray',
  transparent: 'transparent',
};

export const SIZES = {
  tiny: 'tiny',
  small: 'small',
};

export const ALIGN = {
  left: 'left',
  right: 'right',
  center: 'center',
};
